import template from './index.vue'
import gloab from '@/views/customKeyPage/components/gloab'
export default (code) => {
  return gloab(code, template)
}
